import React from "react";
import PropTypes from "prop-types";
import "./LinkCard.scss";

const LinkGrid = ({ children, columns = 3 }) => {
  const style = { ["--lc-columns-desktop"]: columns };
  return (
    <div className="link-grid" style={style}>
      {children}
    </div>
  );
};

LinkGrid.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
};

export default LinkGrid;
